var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gmap-autocomplete',{staticClass:"location-input",attrs:{"placeholder":_vm.label,"value":_vm.inputValue},on:{"place_changed":_vm.eventPlace,"input":function($event){_vm.inputValue = $event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }